import { ChainId } from '@cronos-app/sdk';

export const cdcCardTopUpHistorySubgraph: Record<string, string | undefined> = {
  [ChainId.CRONOS_EVM_MAINNET]:
    'https://graph-v2.cronoslabs.com/subgraphs/name/debit-card-topup/mainnet',
  [ChainId.CRONOS_EVM_TESTNET]:
    'https://graph-v2.cronoslabs.com/subgraphs/name/debit-card-topup/testnet',
} as const;
